import { connect } from "react-redux";
import AddEditBatchForm from "../../../components/ClientSettings/BatchManagement/AddEditBatchForm";
import {
  CommonHeader,
  ContentArea,
  ErrorSuccessModal,
} from "../../../components/commons";
import { UserIcon } from "../../../components/Icon";
import {
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetMessage,
} from "../../../redux/clientSettings";
import { resetMasterStatusCode } from "../../../redux/masterData";
import { resetSession } from "../../../redux/auth";
import { RootState } from "../../../redux/rootReducers";
import { useEffect } from "react";

type AppProps = {
  history: any;
  success: number | null;
  fetching: boolean;
  message: string | null;
  statusCode: number | null;
  error: string | null;
  token: string | null;
  dispatchResetClientSettingMessage: () => void;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetClientSettingsSuccess: () => void;
  dispatchResetClientSettingsError: () => void;
  dispatchResetSession: () => void;
};

const AddBatchManagement = ({
  history,
  success,
  fetching,
  message,
  statusCode,
  error,
  token,
  dispatchResetClientSettingMessage,
  dispatchResetMasterStatusCode,
  dispatchResetClientSettingsSuccess,
  dispatchResetClientSettingsError,
  dispatchResetSession,
}: AppProps) => {
  let { pathname } = history?.location;

  const client_code = history?.location?.state?.client_code;
  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";

  useEffect(() => {
    dispatchResetClientSettingMessage();
    dispatchResetClientSettingsSuccess();
    dispatchResetClientSettingsError();
  }, []);

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterStatusCode();
              dispatchResetClientSettingsSuccess();
              dispatchResetClientSettingsError();
            }}
          />
        );
      }
    }
    return false;
  };
  return (
    <>
      <div className="col-md-4 mb-3">
        <CommonHeader
          title={`${pathname?.includes("add") ? "Add" : "Edit"}  Batch`}
        />
        <div className="d-flex align-items-center">
          {client_code ? (
            <>
              <UserIcon /> &nbsp;
              {company_name} {"(" + client_code + ")"}
            </>
          ) : null}
        </div>
      </div>

      <ContentArea>
        <AddEditBatchForm
          history={history}
          client_code={client_code}
          company_name={company_name}
        />
      </ContentArea>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.clientSettings.success,
  fetching: state.clientSettings.fetching,
  message: state.clientSettings.message,
  statusCode: state.clientSettings.statusCode,
  error: state.clientSettings.error,
  singlebatchDetailsData: state.clientSettings.singlebatchDetailsData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),

  dispatchResetClientSettingMessage: () => dispatch(resetMessage()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetClientSettingsSuccess: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddBatchManagement);
